import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BackgroundVerificationService } from '../../../Model/BackgroundVerification/background-verification.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-bgvcheck-list',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent, NgSelectModule, FormsModule],
  templateUrl: './bgvcheck-list.component.html',
  styleUrl: './bgvcheck-list.component.scss'
})
export class BGVCheckListComponent {
  isDisabled: boolean = false;
  Filter = {
    ess_bgvApiMasterId: null as any
  }

  Vendors = [] as any;
  TableDatas: any[] = [];

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private backgroundVerification: BackgroundVerificationService,
    protected common: CommonService,
    private toast: ToastService,
    private Session: SessionService
  ) {
    //this.common.getPageRights();
    this.common.PageRight.IsAdd = true;
    this.common.PageRight.IsEdit = true;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_BGVFillCombo('API');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.ESS_BGVFillCombo('S');
    }
    else {
      form.submitted = true;
    }
  }

  ESS_BGVFillCombo(SelectType: string) {
    if (SelectType == 'API') {
      this.Vendors = [];
    } else if (SelectType == 'S') {
      this.TableDatas = [];
    }

    this.isDisabled = true;
    this.backgroundVerification.ESS_BGVFillCombo({ SelectType: SelectType, ESS_BGVCheckListMasterID: 0, ESS_BGVApiMasterID: this.Filter.ess_bgvApiMasterId }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (SelectType == 'API') {
            this.Vendors = response.Table;
            this.Filter.ess_bgvApiMasterId = response.Table[0].ESS_BGVApiMasterID;
            this.ESS_BGVFillCombo('S');
          } else if (SelectType == 'S') {
            this.TableDatas = response.Table;
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Clear() {
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
